/**
 * @param list - list of strings representing the selections
 * @param startWord - word that begins the chip statement
 * @param endWord - word that ends the chip statement
 * @returns string
 */
export var selectListMessaging = function (list, options, startWord, endWord) {
    var listValues = options === null || options === void 0 ? void 0 : options.filter(function (o) { return list.includes(o.id); });
    if (!listValues || !listValues.length) {
        return null;
    }
    else if (listValues.length === 1) {
        return "".concat(startWord, " \"").concat(listValues[0].name, "\"");
    }
    else {
        return "".concat(startWord, " these ").concat(listValues.length, " ").concat(endWord);
    }
};
